module.exports = __webpack_public_path__ + "static/media/favicon.e3f72d55.ico";